import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import classes from "../../Purchase.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Loader from "../../../../components/Loader/Loader";
import Card from "../../../../components/Card/Card";
import Button from "../../../../components/Button/Button";
import { PurchaseServices } from "../../../../services/purchase_services";
import { BASE_PATH_TO_POINT_PURCHASE_VOUCHERS_LIST } from "../../../../base_routes_paths/purchase_paths";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_HOME } from "../../../../base_routes_paths/data_paths";

const UpdatePointPurchaseVoucher = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [AndroidproductId, setAndroidproductId] = useState("");
    const [IOSproductId, setIOSproductId] = useState("");
    const [PointVoucherImageLink, setPointVoucherImageLink] = useState("");
    const [point, setPoint] = useState("");
    const [SortID, setSortID] = useState("");
    const [Amount, setAmount] = useState(0);
    const [price, setPrice] = useState("");
    const [Country, setCountry] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [IsLoaderLoading, setIsLoaderLoading] = useState(false);
    const [IsActive, setIsActive] = useState(true);
    const { token } = AUTH_CONTEXT();
    const [isDataFetched, setIsDataFetched] = useState(false);

    const FetchResponse = async () => {
        try {
            let response = await PurchaseServices.getAllPointPurchaseVouchers(token, navigate, params.ID);
            if (response.status === 207) {
                return toast
                    .error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
            }
            setIsDataFetched(true);
            setIsLoaderLoading(false);
            toast.success("Data added successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return response.data;
        } catch (e) {
            setIsDataFetched(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        async function FetchData() {
            try {
                if (!isDataFetched) {
                    let result = await FetchResponse();
                    setPoint(result.Point)
                    setPrice(result.Price)
                    setAndroidproductId(result.AndroidproductId)
                    setIOSproductId(result.IOSproductId)
                    setSortID(result.SortID)
                    setIsActive(result.IsActive)
                    setPointVoucherImageLink(result.PointVoucherImageLink)
                    setCountry(result.Country)
                    setAmount(result.amount)
                }
            } catch (error) {
                toast.error(error.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        }

        if (params.ID) {
            FetchData();
            setIsLoaderLoading(true);
        }
    }, []);

    const SubmitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const Data = {
            Point: point,
            AndroidproductId: AndroidproductId,
            IOSproductId: IOSproductId,
            PointVoucherImageLink: PointVoucherImageLink,
            Price: price,
            Country: Country,
            IsActive: IsActive,
            SortID: SortID,
            amount: Amount
        }

        const FetchApi = async () => {
            try {
                let response = await PurchaseServices.updatePointPurchaseVouchers(token, navigate, params.ID, Data)
                if (response.status === 207) {
                    return toast
                        .error(response.error, {
                            position: "bottom-left",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: false,
                            progress: undefined,
                            theme: "light",
                        })
                }
                setIsLoading(false);
                navigate(BASE_PATH_TO_POINT_PURCHASE_VOUCHERS_LIST);
                toast.success("Data added successfully!!", {
                    position: "bottom-left",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } catch (e) {
                setIsLoading(false);
                toast.error(e.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        };
        FetchApi();
    };

    return (
        IsLoaderLoading ? <Loader /> :
            <div className={classes.crumbs}>
                <Breadcrumbs aria-label="breadcrumb" >
                    <Link underline="hover" color="inherit" href={BASE_PATH_TO_HOME}>
                        Dashboard
                    </Link>
                    <Typography color="text.primary">
                        Purchase
                    </Typography>
                    <Typography color="text.primary">Update Point Purchase Voucher</Typography>
                </Breadcrumbs>
                <Card className={classes.input}>
                    <div className={classes.Main_div}>Update Point Purchase Voucher</div>
                    <form onSubmit={SubmitHandler}>
                        <div className={classes.control}>
                            <label htmlFor="SortID">SortID</label>
                            <input
                                type="number"
                                id="SortID"
                                required
                                value={SortID}
                                onChange={(e) => setSortID(parseInt(e.target.value))}
                                placeholder="Enter SortID"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="AndroidproductId">AndroidproductId</label>
                            <input
                                type="text"
                                id="AndroidproductId"
                                required
                                value={AndroidproductId}
                                onChange={(e) => setAndroidproductId(e.target.value)}
                                placeholder="Enter AndroidproductId"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="IOSproductId">IOSproductId</label>
                            <input
                                type="text"
                                id="IOSproductId"
                                required
                                value={IOSproductId}
                                onChange={(e) => setIOSproductId(e.target.value)}
                                placeholder="Enter IOSproductId"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="Point">Point</label>
                            <input
                                type="number"
                                id="Point"
                                required
                                value={point}
                                onChange={(e) => setPoint(parseInt(e.target.value))}
                                placeholder="Enter point"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="Price">Price</label>
                            <input
                                type="text"
                                id="Price"
                                required
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                placeholder="Enter price of voucher"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="Amount">Amount</label>
                            <input
                                type="number"
                                id="Amount"
                                required
                                value={Amount}
                                onChange={(e) => setAmount(parseInt(e.target.value))}
                                placeholder="Enter Amount"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="Country">Country</label>
                            <input
                                type="text"
                                id="Country"
                                required
                                value={Country}
                                onChange={(e) => setCountry(e.target.value)}
                                placeholder="Enter Country code( eg: IN / US)"
                            />
                        </div>

                        <div className={classes.control}>
                            <label htmlFor="PointVoucherImageLink">PointVoucherImageLink</label>
                            <input
                                type="url"
                                id="PointVoucherImageLink"
                                required
                                value={PointVoucherImageLink}
                                onChange={(e) => setPointVoucherImageLink(e.target.value)}
                                placeholder="Enter PointVoucherImageLink"
                            />
                        </div>

                        <div className={classes.selectbox} style={{ marginBottom: "1rem" }}>
                            <label htmlFor="IsActive">IsActive : </label>
                            <select
                                name="IsActive"
                                id="IsActive"
                                value={IsActive}
                                onChange={(e) => setIsActive(e.target.value)}
                            >
                                <option value="false">False</option>
                                <option value="true">True</option>
                            </select>
                        </div>

                        {!isLoading && <Button type="submit">Update</Button>}
                        {isLoading && <p color="white">Sending request...</p>}
                    </form>
                </Card>
            </div>
    );
};

export default UpdatePointPurchaseVoucher;
